<template>
    <div class="page-container bg-gray-50 dark:bg-gray-900">
        <main-content :page="page" :class="css">
            <slot></slot>
        </main-content>
    </div>
</template>

<style lang="less">
.page-container {
  display: flex;
  width: 100%;
  height: 100vh;
  vertical-align: top;
  border-collapse: collapse;
  border-spacing: 0px;
}
</style>

<script>
import MainContent from './MainContent'
export default {
    props: {
        page: {
            type: Boolean,
            required: true
        },
        css: {
            type: String,
            default: null
        }
    },
    components: {
        MainContent
    }
}
</script>


